module.exports = __webpack_public_path__ + "img/228.3b9797db.jpg";